import enTranslations from "./en.json";

export const resources = {
  en: { translation: enTranslations },
};
